import { getSystemDetails, formatToIST } from "./formatting";

// Opens a print-friendly report window for the given section
export const printReport = (section, sortedLicenses, sortedSystems, sortedCameras, systems) => {
  const win = window.open('', '_blank');
  const now = new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
  let rows = '';
  let headers = '';
  if (section === 'licenses') {
    headers = '<tr><th>License ID</th><th>System UID</th><th>Project</th><th>Software</th><th>Start Date</th><th>End Date</th><th>Status</th></tr>';
    rows = sortedLicenses.map(l => {
      const sys = getSystemDetails(systems, l.uuid);
      const isActive = new Date(l.end_date) >= new Date();
      return `<tr>
        <td>${l.license_id || ''}</td>
        <td style="font-family:monospace">${l.uuid || ''}</td>
        <td>${sys?.project_id || 'N/A'}</td>
        <td>${sys?.software_id || 'N/A'}</td>
        <td>${l.start_date || ''}</td>
        <td>${l.end_date || ''}</td>
        <td style="color:${isActive ? 'green' : 'red'}">${isActive ? 'Active' : 'Expired'}</td>
      </tr>`;
    }).join('');
  } else if (section === 'systems') {
    headers = '<tr><th>System UID</th><th>Project ID</th><th>Software ID</th><th>AMC</th><th>Registered At</th></tr>';
    rows = sortedSystems.map(s => `<tr>
      <td style="font-family:monospace">${s.uuid || ''}</td>
      <td>${s.project_id || 'N/A'}</td>
      <td>${s.software_id || 'N/A'}</td>
      <td>${s.amc ? 'Active' : 'Inactive'}</td>
      <td>${formatToIST(s.registered_at)}</td>
    </tr>`).join('');
  } else if (section === 'cameras') {
    headers = '<tr><th>ID</th><th>System UID</th><th>Project</th><th>Camera Serial</th><th>Status</th><th>Registered At</th></tr>';
    rows = sortedCameras.map(c => {
      const sys = getSystemDetails(systems, c.uuid);
      return `<tr>
        <td>${c.id || ''}</td>
        <td style="font-family:monospace">${c.uuid || ''}</td>
        <td>${sys?.project_id || 'N/A'}</td>
        <td>${c.camera_serial || ''}</td>
        <td style="color:${c.status === 'online' ? 'green' : 'gray'}">${c.status || ''}</td>
        <td>${formatToIST(c.registered_at)}</td>
      </tr>`;
    }).join('');
  }
  win.document.write(`<!DOCTYPE html>
<html>
<head>
  <title>Spookfish - ${section} Report</title>
  <style>
    body { font-family: Arial, sans-serif; margin: 30px; color: #111; }
    h1 { font-size: 20px; margin-bottom: 4px; }
    .meta { font-size: 12px; color: #666; margin-bottom: 20px; }
    table { border-collapse: collapse; width: 100%; font-size: 12px; }
    th { background: #0E1626; color: white; padding: 8px 12px; text-align: left; }
    td { padding: 7px 12px; border-bottom: 1px solid #D8E1E8; }
    tr:nth-child(even) { background: #EAF0F4; }
    @media print { body { margin: 15px; } }
  </style>
</head>
<body>
  <h1>Spookfish License Manager — ${section.charAt(0).toUpperCase() + section.slice(1)} Report</h1>
  <div class="meta">Generated: ${now} | Total records: ${section === 'licenses' ? sortedLicenses.length : section === 'systems' ? sortedSystems.length : sortedCameras.length}</div>
  <table><thead>${headers}</thead><tbody>${rows}</tbody></table>
  <script>window.onload = function() { window.print(); }</script>
</body>
</html>`);
  win.document.close();
};
